import {
  heroAdjustmentsHorizontal,
  heroArrowDown,
  heroArrowDownTray,
  heroArrowLeft,
  heroArrowLeftStartOnRectangle,
  heroArrowPath,
  heroArrowPathRoundedSquare,
  heroArrowRight,
  heroArrowsPointingOut,
  heroArrowTopRightOnSquare,
  heroArrowTrendingUp,
  heroArrowUp,
  heroArrowUpOnSquare,
  heroArrowUpTray,
  heroArrowUturnDown,
  heroArrowUturnLeft,
  heroBanknotes,
  heroBars3,
  heroBarsArrowUp,
  heroBolt,
  heroBookOpen,
  heroBuildingOffice2,
  heroCalendar,
  heroChartBar,
  heroChartBarSquare,
  heroChartPie,
  heroCheck,
  heroCheckCircle,
  heroChevronDoubleLeft,
  heroChevronDoubleRight,
  heroChevronDown,
  heroChevronLeft,
  heroChevronRight,
  heroChevronUp,
  heroClock,
  heroCloudArrowUp,
  heroCodeBracketSquare,
  heroCog6Tooth,
  heroCreditCard,
  heroCurrencyDollar,
  heroCurrencyEuro,
  heroDocument,
  heroDocumentArrowUp,
  heroDocumentChartBar,
  heroDocumentCurrencyEuro,
  heroDocumentDuplicate,
  heroDocumentMagnifyingGlass,
  heroDocumentPlus,
  heroDocumentText,
  heroEllipsisHorizontal,
  heroEnvelope,
  heroExclamationCircle,
  heroExclamationTriangle,
  heroEye,
  heroFire,
  heroFlag,
  heroFolder,
  heroFunnel,
  heroHandThumbUp,
  heroHome,
  heroInformationCircle,
  heroLifebuoy,
  heroLightBulb,
  heroLink,
  heroListBullet,
  heroLockClosed,
  heroMagnifyingGlass,
  heroMapPin,
  heroMegaphone,
  heroMinus,
  heroNumberedList,
  heroPaperAirplane,
  heroPaperClip,
  heroPencilSquare,
  heroPlus,
  heroPower,
  heroPresentationChartLine,
  heroPuzzlePiece,
  heroRocketLaunch,
  heroScale,
  heroServer,
  heroServerStack,
  heroShare,
  heroSignalSlash,
  heroSquares2x2,
  heroSquaresPlus,
  heroSun,
  heroTrash,
  heroUserCircle,
  heroUserGroup,
  heroWallet,
  heroXCircle,
  heroXMark,
} from '@ng-icons/heroicons/outline';

import {
  heroCheckCircleSolid,
  heroMoonSolid,
  heroPhotoSolid,
  heroQuestionMarkCircleSolid,
  heroSunSolid,
  heroUserCircleSolid,
} from '@ng-icons/heroicons/solid';

export const COMMON_ICONS = {
  heroPlus,
  heroChevronDown,
  heroChevronRight,
  heroChevronUp,
  heroChevronLeft,
  heroInformationCircle,
  heroXMark,
  heroBars3,
  heroSquares2x2,
  heroChartPie,
  heroMapPin,
  heroDocumentText,
  heroCog6Tooth,
  heroCheck,
  heroExclamationCircle,
  heroXCircle,
  heroArrowRight,
  heroArrowLeft,
  heroMagnifyingGlass,
  heroEnvelope,
  heroEye,
  heroCurrencyDollar,
  heroCheckCircle,
  heroCheckCircleSolid,
  heroHome,
  heroServer,
  heroServerStack,
  heroPencilSquare,
  heroTrash,
  heroQuestionMarkCircleSolid,
  heroBolt,
  heroFire,
  heroMoonSolid,
  heroSunSolid,
  heroArrowTopRightOnSquare,
  heroArrowPath,
  heroFunnel,
  loadingSpinner:
    '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>',
  heroBookOpen,
  heroLink,
  heroListBullet,
  heroDocumentPlus,
  heroFlag,
  heroArrowPathRoundedSquare,
  heroCurrencyEuro,
  heroBanknotes,
  heroBarsArrowUp,
  heroUserGroup,
  heroPresentationChartLine,
  heroArrowUpTray,
  heroDocument,
  heroArrowUturnDown,
  heroArrowLeftStartOnRectangle,
  heroPhotoSolid,
  heroClock,
  heroUserCircle,
  heroUserCircleSolid,
  heroHandThumbUp,
  heroArrowUturnLeft,
  heroChevronDoubleLeft,
  heroChevronDoubleRight,
  heroMegaphone,
  heroNumberedList,
  heroDocumentCurrencyEuro,
  heroDocumentChartBar,
  heroDocumentArrowUp,
  heroDocumentMagnifyingGlass,
  heroCodeBracketSquare,
  heroPaperClip,
  heroCreditCard,
  heroLightBulb,
  heroArrowDownTray,
  heroPaperAirplane,
  heroMinus,
  roundedSquare:
    '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72 2.16C9.72 1.56353 9.23647 1.08 8.64 1.08H2.16C1.56353 1.08 1.08 1.56353 1.08 2.16V8.64C1.08 9.23647 1.56353 9.72 2.16 9.72H8.64C9.23647 9.72 9.72 9.23647 9.72 8.64V2.16ZM10.8 8.64C10.8 9.83293 9.83293 10.8 8.64 10.8H2.16C0.967065 10.8 0 9.83293 0 8.64L0 2.16C1.85549e-07 0.967065 0.967065 0 2.16 0L8.64 0C9.83293 0 10.8 0.967065 10.8 2.16V8.64Z" fill="currentColor"/></svg>',
  heroSun,
  heroLockClosed,
  heroChartBarSquare,
  heroWallet,
  heroArrowsPointingOut,
  heroArrowTrendingUp,
  heroPuzzlePiece,
  heroCalendar,
  heroLifebuoy,
  heroSignalSlash,
  heroExclamationTriangle,
  heroPower,
  heroFolder,
  heroCloudArrowUp,
  heroEllipsisHorizontal,
  heroArrowUpOnSquare,
  heroAdjustmentsHorizontal,
  heroDocumentDuplicate,
  heroChartBar,
  heroArrowDown,
  heroArrowUp,
  heroSquaresPlus,
  heroBuildingOffice2,
  heroScale,
  heroRocketLaunch,
  heroShare,
  dragDots:
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.56961 13.1585C8.52843 13.1585 9.30572 13.944 9.30572 14.9129C9.30572 15.8819 8.52843 16.6673 7.56961 16.6673C6.61078 16.6673 5.8335 15.8819 5.8335 14.9129C5.8335 13.944 6.61078 13.1585 7.56961 13.1585Z" fill="currentColor"/><path d="M12.4307 13.1585C13.3895 13.1585 14.1668 13.944 14.1668 14.9129C14.1668 15.8819 13.3895 16.6673 12.4307 16.6673C11.4719 16.6673 10.6946 15.8819 10.6946 14.9129C10.6946 13.944 11.4719 13.1585 12.4307 13.1585Z" fill="currentColor"/><path d="M7.56961 8.24626C8.52843 8.24626 9.30572 9.03173 9.30572 10.0007C9.30572 10.9696 8.52843 11.755 7.56961 11.755C6.61078 11.755 5.8335 10.9696 5.8335 10.0007C5.8335 9.03173 6.61078 8.24626 7.56961 8.24626Z" fill="currentColor"/><path d="M12.4307 8.24626C13.3895 8.24626 14.1668 9.03173 14.1668 10.0007C14.1668 10.9696 13.3895 11.755 12.4307 11.755C11.4719 11.755 10.6946 10.9696 10.6946 10.0007C10.6946 9.03173 11.4719 8.24626 12.4307 8.24626Z" fill="currentColor"/><path d="M7.56961 3.33398C8.52843 3.33398 9.30572 4.11945 9.30572 5.08837C9.30572 6.05729 8.52843 6.84276 7.56961 6.84276C6.61078 6.84276 5.8335 6.05729 5.8335 5.08837C5.8335 4.11945 6.61078 3.33398 7.56961 3.33398Z" fill="currentColor"/><path d="M12.4307 3.33398C13.3895 3.33398 14.1668 4.11945 14.1668 5.08837C14.1668 6.05729 13.3895 6.84276 12.4307 6.84276C11.4719 6.84276 10.6946 6.05729 10.6946 5.08837C10.6946 4.11945 11.4719 3.33398 12.4307 3.33398Z" fill="currentColor"/></svg>',
  // todo: add more icons if needed
};
